/* eslint-disable */
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// If you need to update this file, make changes in the Core application
// then run `import:api` in your terminal from the root of this project.
import { AxiosPromise } from 'axios';

import { baseClientConstructorProps } from 'app/api/apiClient/config';

import { BaseClient, BaseClientConstructorProps, SendRequestPayload } from '../baseClient';
import { 
  LookupPayorNamesRequest,
  GetPayorCompanyResponse,
  LookupPayorNamesResponse
 } from '../types';

  //  CorePayeePayorsClient
class CorePayeePayorsClient extends BaseClient {
    constructor(props: BaseClientConstructorProps) {
        super(props);
    }

    readonly getCompany = (id: string): AxiosPromise<GetPayorCompanyResponse> => {
        let url_ = "/api/v1/core/payee/payors/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly lookupNames = (payload: LookupPayorNamesRequest): AxiosPromise<LookupPayorNamesResponse> => {
        let url_ = "/api/v1/core/payee/payor_names";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }
}
// CorePayeePayorsClient
  
export const corePayeePayorsClient = new CorePayeePayorsClient(baseClientConstructorProps);
